module.exports = __webpack_public_path__ + "static/media/22770053_1629539720454546_7666596906764635266_o.0abfb291.jpg";